import { useTerminalsState } from "@/States/Terminals";
import { useTrans } from "@/translations";

import { REPORTING_VIEW_TYPES } from "../types";

type Props = {
  viewType: REPORTING_VIEW_TYPES;
};

export const ReportingHeader: React.FC<Props> = ({ viewType }) => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsState();

  return (
    <div className="ml-[20px] min-w-[280px] flex-1">
      <h1 className="font-signifier m-0 text-[44px] leading-[1.05] font-normal tracking-[-0.02em] text-[#1D1C1C]">
        {t("reportingPage:title")}
      </h1>
      <p className="font-dm-sans text-grey6 mt-[8px] mb-0 text-[15px]">
        {viewType === REPORTING_VIEW_TYPES.BUILDING
          ? t("reportingPage:subTitleBuilding", {
              buildingName: currentTerminal?.name,
              interpolation: { escapeValue: false },
            })
          : t("reportingPage:subTitlePortfolio")}
      </p>
    </div>
  );
};
